import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccessService } from '../service/access.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { ModalTerminateComponent } from './modal-terminate/modal-terminate.component';

@Component({
  selector: 'app-access-employee-result',
  templateUrl: './access-employee-result.component.html'
})
export class AccessEmployeeResultComponent implements OnInit {

  @Input()id: string;
  status: any=[];
  SeeItems: any=[];
  people: any=[];
  type: any=[];
  qualificationDummy:any=[];
  lang:string;
  facility=true;
  priority=false;
  status_facility= 'App-facility';

  constructor(private route: ActivatedRoute,
              private dataApi: AccessService,
              private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog,
              private router: Router) {

    this.route.snapshot.paramMap.get('id');
    this.id = this.route.snapshot.paramMap.get('id');
  }

  getAccessDetail()
  {
    this.spinner.show("loading")
    this.dataApi.getAccessDetail(this.id).subscribe((data: any) => {
      this.lang = sessionStorage.getItem('lang')
      this.qualificationDummy=data.qualificationDummy;
      this.SeeItems=data;
      this.type=data.type;
      this.status=data.status;
      this.people=data.people;
      this.spinner.hide("loading")},
                                                    (err) => {
                                                      this.spinner.hide("loading");
                                                      if(err.error.error !== 'Invalid token.') {
                                                        this.dialog.open(ModErrorComponent, {
                                                          width: 'auto',
                                                          panelClass: 'myapp-no-padding-dialog',
                                                        });
                                                      }
                                                    });
  }

  ngOnInit() {
    this.getAccessDetail();
  }

  openDialogTerminate(status) {
    const dialogRef = this.dialog.open(ModalTerminateComponent, {
      width: 'auto',
      panelClass: 'myapp-no-padding-dialog',
      data: {
        id: this.id,
        status: status
      }
    });

    dialogRef.afterClosed().subscribe((option) => {

      if(option){
        this.router.navigate(['/access-confirmation/' + this.id]);
      }
    });

  }



}
